<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>

<p-toast
  position="center"
  [baseZIndex]="5000"
  *transloco="let t; read: 'message'"
>
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" *ngIf="!!message">
      <div class="p-text-left">
        <h2 class="error-title">{{ message.summary }}</h2>
        <p class="error-detail">{{ message.detail }}</p>
        <p-divider *ngIf="message?.data"></p-divider>
        <p-inplace *ngIf="message?.data" class="error-stacktrace">
          <ng-template pTemplate="display">
            {{ t('details') }}
          </ng-template>
          <ng-template pTemplate="content">
            <div
              class="stacktrace-textarea"
              [innerHTML]="highlighterJson(message.data)"
            ></div>
          </ng-template>
        </p-inplace>
      </div>
      <div class="p-grid p-fluid p-jc-center">
        <div class="p-col-2 flex justify-content-end">
          <button
            type="button"
            pButton
            (click)="clear($event)"
            label="Ok"
            class="p-button-success session-logout-btn"
          ></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
